/**
 * 显示异物入侵图片的小组件
 */
import { getImageStr } from "@/api/device/sensor"
import { Sensor } from "@/global/interface/device/sensor"
import { useEffect, useState } from "react"
import { Image } from "antd";

interface Iprops {
    sensor: Sensor
    setImg?: (img: string) => void
}

export function MonitorInvasionPanel(props: Iprops) {
    const [base64Img, setBase64Img] = useState<string>(null)   //base64格式的图片信息

    useEffect(() => {
        flushData();
        const interval = setInterval(() => {
            flushData();
        }, 5000)

        return () => {
            clearInterval(interval)
        }
    }, [props.sensor])


    const flushData = () => {
        if (props.sensor && props.sensor.id && props.sensor.sensorParameters && props.sensor.sensorParameters.length > 0) {
            const invasionParams = props.sensor.sensorParameters.filter(item => item.symbol === "invasion_image");
            if (invasionParams.length > 0) {
                let paramId = invasionParams[0].id;
                getImageStr(paramId, "invasion_image").then(res2 => {
                    if (res2.status && res2.data) {
                        setBase64Img(res2.data.image);
                        if (props.setImg) {
                            props.setImg(res2.data.image);
                        }
                    } else {
                        let paramId2 = invasionParams[1]?.id;
                        if (paramId2 != null) { 
                            getImageStr(paramId2, "invasion_image").then(res3 => {
                                if (res3.status && res3.data) {
                                    if (props.setImg) {
                                        props.setImg(res3.data.image);
                                    }
                                    setBase64Img(res3.data.image);
                                }
                            })
                        }
                    }
                })
            }
        }
    }

    return (
        <>
            {
                base64Img &&
                <Image
                    src={`data:image/jpeg;base64,${base64Img}`}
                />
            }
            {
                !base64Img &&
                <div className="empty-image">暂无异物入侵识别图</div>
            }
        </>
    )

}